import React, { useState, useEffect } from "react";
import axios from "axios";

const EmployeeGrid = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentEmployee, setCurrentEmployee] = useState(0); // Track the current employee being processed
  const [totalEmployees, setTotalEmployees] = useState(0); // Total employees to be processed


//   const fetchPdfData = async (employeeDocument) => {
//     if (employeeDocument) {
//       const fetchPromises = employeeDocument.map(async (doc) => {
//         const { DocumentTypeName, Attachment } = doc;
//         setLoading(true);
       
//         if (DocumentTypeName && Attachment) {
//           const encodedAttachment = encodeURIComponent(Attachment)
//           const apiUrl = `https://service.khexports.in/api/Common/GetImageURL?bucketName=one-erp-beta&fileName=GD/EmployeeDocument/${encodedAttachment}`;
//           try {
//             console.log(Attachment);
//             const response = await axios.get(apiUrl);
//             const Pdfurls = response.data.ImageURL;
//             console.log(Pdfurls);
//             const imageResponse = await axios.get(Pdfurls, { responseType: 'blob' });
//             const base64Data = await convertBlobToBase64(imageResponse.data);
//             const base64String = base64Data.split(',')[1];
//             // console.log(base64String);
//             return { DocumentTypeName, base64String }; // Return key-value pair for later use
//           } catch (error) {
//             console.error(`Failed to fetch attachment for ${DocumentTypeName}:`, error);
//           }
//         }
//       });

//       // Wait for all fetch operations to complete
//       const results = await Promise.all(fetchPromises);
//       // if(!results){
//       //     setPdfData({});
//       // }
      
//       // Filter out undefined results
//       const validResults = results.filter(result => result);
//       // if(!pdfData){
//           validResults.forEach(({ DocumentTypeName, base64String }) => {
//               setPdfData(prevState => ({
//                 ...prevState,
//                 [DocumentTypeName]: base64String,
//               }));
//             });
//       setLoading(false);
//       console.log(pdfData)
//       // Update the state with the new pdf data
      
//     }
//   };
// useEffect(() => {
//   const fetchEmployeeData = async () => {
//     const body = {
//       pListCategory: "E",
//       pFactoryID: 7,
//       pLoggedInUserID: 49,
//       pSubDivisionID: 2,
//       pPageIndex: 1,
//       pPageSize: 10000,
//       pSearchString: "",
//       pWhereString: "AND A.LiveFlag='1'",
//     };

//     try {
//       const response = await axios.post(
//         "https://service.khexports.in/api/EmployeeMaster/GetEmployeeMasterListNew",
//         body,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const parsedData = JSON.parse(response.data.Data);
//       console.log(parsedData);

      
//       const employeesWithImageStatus = [];
//       for (const employee of parsedData) {
//         const { EmployeeImage, EmployeeNo } = employee;
//         const imageURL = `https://servicestest.khexports.in/api/Common/GetImageURL?bucketName=one-erp-beta&fileName=GD/EmployeePhoto/${EmployeeImage}`;
        
//         try {
//           const imageResponse = await axios.get(imageURL);
//           const imageData = imageResponse.data.ImageData;
//           console.log(imageData);
          
//           if (imageData && imageData !== "") {
//             employeesWithImageStatus.push({ ...employee, imageExists: true });
//           } else {
//             employeesWithImageStatus.push({ ...employee, imageExists: false });
//           }
          
//         } catch (error) {
//           console.error(`Error fetching image for employee ${employee.EmployeeNo}:`, error);
//           employeesWithImageStatus.push({ ...employee, imageExists: false });
//         }
//       }
      
//       console.log(employeesWithImageStatus);

//       setEmployees(employeesWithImageStatus); // State update happens here
//     } catch (error) {
//       console.error("Error fetching employee data:", error);
//     }
//   };

//   fetchEmployeeData();
// }, []);



  // const download = async () => {
  //   const body = {
  //     pListCategory: "E",
  //     pFactoryID: 2,
  //     pLoggedInUserID: 49,
  //     pSubDivisionID: 2,
  //     pPageIndex: 1,
  //     pPageSize: 10000,
  //     pSearchString: "",
  //     pWhereString: "AND A.LiveFlag='1'",
  //   };

  //   try {
  //     const response = await axios.post(
  //       "https://service.khexports.in/api/EmployeeMaster/GetEmployeeMasterListNew",
  //       body,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     const parsedData = JSON.parse(response.data.Data);
  //     console.log(parsedData);

  //     // Additional logic to process employee image data
  //     // Uncomment the code below to fetch employee images
      
  //     const employeesWithImageStatus = [];
  //     for (const employee of parsedData) {
  //       const { EmployeeImage, EmployeeNo } = employee;
  //       const imageURL = `https://servicestest.khexports.in/api/Common/GetImageURL?bucketName=one-erp-beta&fileName=GD/EmployeePhoto/${EmployeeImage}`;
        
  //       try {
  //         setLoading(true);
  //         const imageResponse = await axios.get(imageURL);
  //         const imageData = imageResponse.data.ImageData;
  //         console.log(imageData);
          
  //         if (imageData && imageData !== "") {
  //           employeesWithImageStatus.push({ ...employee, imageExists: true });
  //         } else {
  //           employeesWithImageStatus.push({ ...employee, imageExists: false });
  //         }
          
  //       } catch (error) {
  //         console.error(`Error fetching image for employee ${employee.EmployeeNo}:`, error);
  //         employeesWithImageStatus.push({ ...employee, imageExists: false });
  //       }
  //     }

  //     setLoading(false);
      
  //     console.log(employeesWithImageStatus);

  //     setEmployees(employeesWithImageStatus); // State update happens here
  //   } catch (error) {
  //     console.error("Error fetching employee data:", error);
  //   }
  // };

  const data = [
    { factoryid: 4, subdivision: 1, factoryname: "FWD" },
    { factoryid: 2, subdivision: 2, factoryname: "GD" },
    { factoryid: 3, subdivision: 22, factoryname: "TAD" },
    { factoryid: 7, subdivision: 17, factoryname: "RF" },
    { factoryid: 5, subdivision: 4, factoryname: "LGD" },
    { factoryid: 5, subdivision: 20, factoryname: "LGD" ,subcat:"LPD"},
    { factoryid: 5, subdivision: 23, factoryname: "LGD" ,subcat:"unit3"},
    { factoryid: 5, subdivision: 24, factoryname: "LGD",subcat:"unit4" },
    // { factoryid: 5, subdivision: 6, factoryname: "RAB" },
  ];


  const download = async () => {
    const storedResponse = JSON.parse(sessionStorage.getItem("response"));
    const factoryID = storedResponse?.FactoryID;
    const SubDivisionID= storedResponse?.SubDivisionID;
    console.log(SubDivisionID)// Assuming factoryID comes from sessionStorage
    console.log(factoryID);
    const userID = storedResponse?.UserID; // Assuming userID comes from sessionStorage
    console.log(userID);
    // Check if the factoryID exists in the data array
    const factoryData = data.find(item => item.subdivision === SubDivisionID);
    console.log(factoryData);
    if (factoryData) {
      // Found matching factoryID, now proceed with body update
      const body = {
        pListCategory: "E",
        pFactoryID: factoryData.factoryid,
        pLoggedInUserID: userID , // Default to 49 if no userID
        pSubDivisionID: factoryData.subdivision,
        pPageIndex: 1,
        pPageSize: 10000,
        pSearchString: "",
        pWhereString: "AND A.LiveFlag='1'",
      };

    try {
      const response = await axios.post(
        "https://service.khexports.in/api/EmployeeMaster/GetEmployeeMasterListNew",
        body,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const parsedData = JSON.parse(response.data.Data);
      console.log(parsedData)
      setTotalEmployees(parsedData.length); // Set total number of employees

      const employeesWithImageStatus = [];
      setLoading(true);
      for (let i = 0; i < parsedData.length; i++) {
        const employee = parsedData[i];
        const { EmployeeImage, EmployeeNo } = employee;
        const imageURL = `https://service.khexports.in/api/Common/GetImageURL?bucketName=one-erp-beta&fileName=${factoryData.factoryname}/EmployeePhoto/${EmployeeImage}`;
       // console.log(imageURL);

        setCurrentEmployee(i + 1); // Update current employee being processed

        try {
          const imageResponse = await axios.get(imageURL);
          const imageData = imageResponse.data.ImageData;

          if (imageData && imageData !== "") {
            employeesWithImageStatus.push({ ...employee, imageExists: true });
          } else {
            employeesWithImageStatus.push({ ...employee, imageExists: false });
          }
        } catch (error) {
          console.error(`Error fetching image for employee ${EmployeeNo}:`, error);
          employeesWithImageStatus.push({ ...employee, imageExists: false });
        }
      }

      setEmployees(employeesWithImageStatus); // Update state with employees data
    } catch (error) {
      console.error("Error fetching employee data:", error);
    } finally {
       setLoading(false); // Stop loading after processing
    }
  };
}
  // const download = async () => {
  //   const storedResponse = JSON.parse(sessionStorage.getItem("response"));

    
  //    // Start loading
  //   const body = {
  //     pListCategory: "E",
  //     pFactoryID: 4,
  //     pLoggedInUserID: 49,
  //     pSubDivisionID: 1,
  //     pPageIndex: 1,
  //     pPageSize: 10000,
  //     pSearchString: "",
  //     pWhereString: "AND A.LiveFlag='1'",
  //   };

  //   try {
  //     const response = await axios.post(
  //       "https://service.khexports.in/api/EmployeeMaster/GetEmployeeMasterListNew",
  //       body,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     const parsedData = JSON.parse(response.data.Data);
  //     console.log(parsedData)
  //     setTotalEmployees(parsedData.length); // Set total number of employees

  //     const employeesWithImageStatus = [];
  //     // setLoading(true);
  //     // for (let i = 0; i < parsedData.length; i++) {
  //     //   const employee = parsedData[i];
  //     //   const { EmployeeImage, EmployeeNo } = employee;
  //     //   const imageURL = `https://service.khexports.in/api/Common/GetImageURL?bucketName=one-erp-beta&fileName=GD/EmployeePhoto/${EmployeeImage}`;

  //     //   setCurrentEmployee(i + 1); // Update current employee being processed

  //     //   try {
  //     //     const imageResponse = await axios.get(imageURL);
  //     //     const imageData = imageResponse.data.ImageData;

  //     //     if (imageData && imageData !== "") {
  //     //       employeesWithImageStatus.push({ ...employee, imageExists: true });
  //     //     } else {
  //     //       employeesWithImageStatus.push({ ...employee, imageExists: false });
  //     //     }
  //     //   } catch (error) {
  //     //     console.error(`Error fetching image for employee ${EmployeeNo}:`, error);
  //     //     employeesWithImageStatus.push({ ...employee, imageExists: false });
  //     //   }
  //     // }

  //     // setEmployees(employeesWithImageStatus); // Update state with employees data
  //   } catch (error) {
  //     console.error("Error fetching employee data:", error);
  //   } finally {
  //     // setLoading(false); // Stop loading after processing
  //   }
  // };

  // Call download function when needed, e.g., on button click or component mount
  // useEffect(() => {
  //   download();
  // }, []);





// useEffect(() => {
//   // This will log the updated 'employees' state after it has changed
//   console.log("Updated employees:", employees);
// }, [employees]);


//   useEffect(() => {
//     console.log("Updated employees:", employees);
//   }, [employees]);
  
  const noImageEmployees = employees.filter((employee) => !employee.imageExists); // Filter employees with imageExists === false
const noImageCount = noImageEmployees.length;


  if (loading) {
    return (
      <div className="flex flex-col justify-center items-center fixed top-0 left-0 w-full h-full bg-transparent z-50">
        <span className="sr-only">Loading...</span>
        <div className="flex space-x-2 mb-4">
          <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.3s]"></div>
          <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.15s]"></div>
          <div className="h-8 w-8 bg-black rounded-full animate-bounce"></div>
        </div>
        <p>{`Loading ${currentEmployee} of ${totalEmployees} employees...`}</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto">
    <h1 className="text-2xl font-bold mb-4 mt-3">Employee Missing Photos in S3 Bucket</h1>
  <div className="flex space-x-2 items-center text-center justify-center mb-2">
  <p>Total employees with no Profile: {noImageCount}</p>
    <button
    onClick={download}
             
              className=" ml-2 p-2 bg-blue-500 text-white rounded-md shadow-md"
            >
              Check
            </button>
  </div>
  <table className="table-auto w-full border-collapse border border-black">
  <thead>
    <tr className="bg-gray-100">
      <th className="border px-2 py-2 text-center">S.No.</th>
      <th className="border px-4 py-2 text-center">Employee Code</th>
      <th className="border px-4 py-2 text-center">Image Exists</th>
    </tr>
  </thead>
  <tbody>
    {employees
      .filter((employee) => !employee.imageExists) // Filter employees with imageExists === false
      .map((employee, index) => (
        <tr key={employee.EmployeeNo} className="odd:bg-white even:bg-gray-50">
          <td className="border px-2 py-2 text-center">{index + 1}</td> {/* Serial Number */}
          <td className="border px-4 py-2">{employee.EmployeeCode}</td>
          <td className="border px-4 py-2 text-center">
            <span className="font-bold">No</span>
          </td>
        </tr>
      ))}
  </tbody>
</table>

  </div>
  
  );
};

export default EmployeeGrid;
